import { useConvertFromPenceFactory } from "$routes/_lib/use-convert-currency";
import useCurrencyFormat from "$routes/_lib/use-currency-format";
import { useCallback } from "react";

export default function useCurrencyFormatter() {
  const currency = useCurrencyFormat();
  const convertFromPence = useConvertFromPenceFactory();

  const currencyFormatter = useCallback(
    (amountInPence: number) => currency.format(convertFromPence(amountInPence)),
    [currency, convertFromPence],
  );

  return { currencyFormatter };
}
